{
  "until": "{{duration}} menuju {{prayer}}",
  "begin_focus": "Mulai fokus",
  "add_task": "Tambah tugas",
  "more_tasks": "+{{count}} lagi",
  "fajr_at": "Subuh pukul {{time}}",
  "schedule_title": "Hari Ini",
  "plan_my_day": "Rencanakan hari saya",
  "planning": "Merencanakan…",
  "suggested": "Disarankan",
  "keep_plan": "Simpan rencana",
  "undo_plan": "Urungkan",
  "plan_error": "Tidak dapat merencanakan sekarang. Coba lagi.",
  "plan_empty": "Belum ada yang direncanakan — tambahkan tugas dulu.",
  "plan_settled": "Semua sudah pada tempatnya.",
  "view_list": "Daftar",
  "view_switch_aria": "Beralih antara tampilan daftar dan hari",
  "unassigned": "Belum dijadwalkan",
  "assign_title": "Blok salat",
  "no_block": "Tanpa blok",
  "assign_aria": "Tetapkan ke blok salat",
  "open_schedule_aria": "Buka jadwal hari ini",
  "focus_session_label": "{{block}} · Fokus",
  "block_hero": "Kerja mendalam hingga {{prayer}}",
  "moments_away": "{{prayer}} sebentar lagi",
  "block_clear": "Semua selesai — istirahat hingga {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Tekan Esc untuk keluar perlahan",
  "exit_hint_touch": "Ketuk ✕ untuk keluar perlahan",
  "mark_done_aria": "Tandai tugas selesai",
  "quick_add_placeholder": "Tambahkan ke blok ini…",
  "focus_task_aria": "Fokus pada tugas ini"
}
